import { render, staticRenderFns } from "./buttons-appointments.vue?vue&type=template&id=0f145b49&scoped=true"
import script from "./buttons-appointments.vue?vue&type=script&lang=ts"
export * from "./buttons-appointments.vue?vue&type=script&lang=ts"
import style0 from "./buttons-appointments.vue?vue&type=style&index=0&id=0f145b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f145b49",
  null
  
)

export default component.exports